import React from 'react';
import ReactDOM from 'react-dom/client';
import SolarSim from './SolarSim';
//import reportWebVitals from './reportWebVitals';

const rootnode = document.getElementById('simroot');
const approot = ReactDOM.createRoot(rootnode);
const initialProps = JSON.parse(rootnode.dataset.init?.length ? rootnode.dataset.init : '{}');
approot.render(
  <React.StrictMode>
    <SolarSim initialProps={initialProps}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
